import { AggRelayEnvironment, createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';

import DiscoverViewProductCheckQuery, {
  DiscoverViewProductCheckQuery as DiscoverViewProductCheckQueryType,
} from '../components/__generated__/DiscoverViewProductCheckQuery.graphql';

export const discoverResource = createRelayResource<DiscoverViewProductCheckQueryType>({
  getQuery: (_, resourceStoreContext) => {
    const context = resourceStoreContext as ResourceContext;
    return {
      query: DiscoverViewProductCheckQuery,
      variables: {
        cloudIds: context.collabContext?.rovoWorkspace ? [context.collabContext.rovoWorkspace] : [],
      },
      environment: AggRelayEnvironment,
    };
  },
  maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
